const error = {
  CREDENTIAL_NOT_ACTIVATED: 'CREDENTIAL_NOT_ACTIVATED',
  KEY_BLOCKED: 'KEY_BLOCKED',
  INCORRECT_KEYPASSWORD_OR_PUK: 'INCORRECT_KEYPASSWORD_OR_PUK',
  USER_SUSPENDED: 'USER_SUSPENDED'
}

export default error
